import { React, useState, useEffect, useContext } from "react";
import Button from "@mui/material/Button";
import { DataGrid, GridActionsCellItem } from '@mui/x-data-grid';
import GridNoRow from '../../../../common/GridNoRow';
import axios from "axios";
import Swal from "sweetalert2";
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import OutgoingRegModal from "../../../../modal/PC/order/OutgoingRegModal";
import OutgoingUpdateModal from "../../../../modal/PC/order/OutgoingUpdateModal";
import styled from "styled-components";
import Select from 'react-select';
import { AppContext } from '../../../../AppStore';
import Moment from 'moment';
import { useNavigate, useLocation } from "react-router-dom";
import { useParams } from 'react-router-dom';

const Outgoing = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const params = useParams();
    const appStore = useContext(AppContext);
    const [MenuID, setMenuID] = useState(0);
    const [MenuName, setMenuName] = useState('');
    const [MenuUpdateExistYN, setMenuUpdateExistYN] = useState('N');
    const [MenuDeleteExistYN, setMenuDeleteExistYN] = useState('N');
    const [MenuUpdateYN, setMenuUpdateYN] = useState('N');
    const [MenuDeleteYN, setMenuDeleteYN] = useState('N');
    const [originRows, setOriginRows] = useState([]);
    const [rows, setRows] = useState([]);
    const [columns, setColumns] = useState([]);
    const [keyword, setKeyword] = useState({
        search:'',
        status:''
    });
    const [userTypeModalOption, setUserTypeModalOption] = useState([]);
    const [qualityYnModalOption, setQualityYnModalOption] = useState([]);
    const [isRegModalOpen, setRegModalOpen] = useState(false);
    const [isUpdateModalOpen, setUpdateModalOpen] = useState(false);
    const [modalTitle, setModalTitle] = useState('');
    const [selectOutgoingID, setSelectOutgoingID] = useState('');
    const [statusOption, setStatusOption] = useState([]);
    const [paramID, setParamID] = useState('');
    const [initialEditOpenDone, setInitialEditOpenDone] = useState(true);
    
    // Grid정의
    const handleSetting = () => {
        setColumns([
            (MenuUpdateExistYN === "Y"?
            {
                field: 'updated',
                headerName: '수정',
                width: 55,
                type:'actions',
                disableClickEventBubbling: true,
                getActions: (params) => [
                    <GridActionsCellItem icon={<EditIcon color="primary" />} onClick={() => {UpdateClick(params)}} label="Edit" />
                ],
                headerAlign: 'center', 
                align:'center'
            } : {}),
            (MenuDeleteExistYN === "Y"?
            {
                field: 'deleted',
                headerName: '삭제',
                width: 55,
                type:'actions',
                disableClickEventBubbling: true,
                getActions: (params) => [
                    <GridActionsCellItem icon={<DeleteIcon color={ MenuDeleteYN === "Y" && params.row.update_flag === 'Y' && params.row.outgoing_status === "D" ? "error" : "grey"} />} onClick={() => {DeleteClick(params)}} label="Delete" disabled={ MenuDeleteYN === "Y" && params.row.update_flag === 'Y' && params.row.outgoing_status === "D" ? false : true } />
                ],
                headerAlign: 'center', 
                align:'center'
            } : {}),
            { field: 'id', headerName: 'outgoing_id', width: 0, headerAlign: 'center' },
            { field: 'outgoing_number', headerName: '출하번호', width: 120, headerAlign: 'center', align:'center'},
            { field: 'outgoing_status', headerName: 'outgoing_status', width: 0, headerAlign: 'center'},
            { field: 'outgoing_status_name', headerName: '출하상태', width: 100, headerAlign: 'center', align:'center'},
            { field: 'outgoing_partner_name', headerName: '출하처', width: 250, headerAlign: 'center', align:'left'},
            { field: 'outgoing_order_info', headerName: '수주정보', width: 250, headerAlign: 'center', align:'left'},
            { field: 'outgoing_partner_manager', headerName: '담당자', width: 120, headerAlign: 'center', align:'left'},
            { field: 'outgoing_partner_manager_phone', headerName: '담당자 휴대폰', width: 160, headerAlign: 'center', align:'left' },
            { field: 'outgoing_partner_manager_mail', headerName: '담당자 메일', width: 250, headerAlign: 'center', align:'left' },
            { field: 'recent_update_user_name', headerName: '최근수정자', width: 120, headerAlign: 'center', align:'center' },
            { field: 'recent_update_datetime', headerName: '최근수정일시', width: 180, headerAlign: 'center', align:'center' },
        ]);
    }

    const [columnVisibilityModel, setColumnVisibilityModel] = useState({
        id: false,
        outgoing_number: true,
        outgoing_status: false,
        outgoing_status_name: true,
        outgoing_partner_name: true,
        outgoing_order_info: true,
        outgoing_partner_manager: true,
        outgoing_partner_manager_phone: true,
        outgoing_partner_manager_mail: true,
        deleted: true,
        updated: true,
        recent_update_user_name: true,
        recent_update_datetime: true,
    });

    useEffect(() => {
        const accessList = JSON.parse(localStorage.getItem("nav"));
        
        if (Array.isArray(accessList) && accessList.filter(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).length > 0) {
            setMenuID(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_id);
            setMenuName(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_name);
            setMenuUpdateExistYN(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_update_exist_yn);
            setMenuDeleteExistYN(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_delete_exist_yn);
            setMenuUpdateYN(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_update_yn);
            setMenuDeleteYN(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_delete_yn);
            
            if(params.outgoing_id !== null && typeof params.outgoing_id !== 'undefined'){
                setParamID(params.outgoing_id);
            }
        }else{
            Swal.fire({
                title: '<p style="color:red">접근 권한 오류</p>',
                text: '화면에 접근 권한이 없습니다.',
                confirmButtonText: '확인',
                confirmButtonColor: '#7066e0',
                timer:5000,
                timerProgressBar: true
            }).then((value) => {
                return navigate(-1);
            });
        }
    }, []);
    
    useEffect(() => {
        if(String(MenuID) !== String(0) && MenuID != null){
            handleView();
        }
    }, [keyword.status])
    
    useEffect(() => {
        if(String(MenuID) !== String(0) && MenuID != null){
            handleSetting();
            handleInitSelect();
            handleInit();
            handleView();
        }
    }, [MenuID]);
    
    useEffect(() => {
        if (originRows.length > 0 && paramID && initialEditOpenDone) {
            const filtered = originRows.filter(row => String(row.outgoing_id) === String(paramID));

            if (filtered.length > 0) {
                setSelectOutgoingID(paramID);
                setUpdateModalOpen(true);
                setModalTitle('출하 수정');
                setInitialEditOpenDone(false);
            }
        }
    }, [originRows, paramID]);

    // Grid 데이터 조회
    const handleView = () => {
        if (appStore.loading) return;
        appStore.setLoading(true);

        axios.get('/api/p/Outgoing/List',
            {
            params : {
              search : keyword.search,
              status : keyword.status
            }
          },
          { withCredentials: true }
        )
        .then((response) => {
            const PermissionMap = {};
            response.data.forEach(row => {
                if (!PermissionMap[row.outgoing_id]) {
                    PermissionMap[row.outgoing_id] = [row.reg_user_id, row.update_user_id, row.outgoing_user_id].includes(Number(localStorage.getItem('user_id')));
                }
            });

            var array = response.data.map((item, index) => ({
                id: item.outgoing_id,
                outgoing_number: item.outgoing_number,
                outgoing_status: item.outgoing_status,
                outgoing_status_name: item.outgoing_status_name,
                outgoing_partner_name: item.outgoing_partner_name,
                outgoing_order_info: (((item.outgoing_order_number === undefined || item.outgoing_order_number === ''? '':'['+item.outgoing_order_number+'] ')+(item.outgoing_order_name === undefined || item.outgoing_order_name === ''? '':item.outgoing_order_name))).trim(),
                outgoing_partner_manager: item.outgoing_partner_manager,
                outgoing_partner_manager_phone: item.outgoing_partner_manager_phone,
                outgoing_partner_manager_mail: item.outgoing_partner_manager_mail,
                recent_update_user_name: (item.update_user_name === undefined || item.update_user_name === ''?item.reg_user_name:item.update_user_name),
                recent_update_datetime: (item.update_datetime === undefined?Moment(item.reg_datetime).format('YYYY-MM-DD HH:mm:ss'):Moment(item.update_datetime).format('YYYY-MM-DD HH:mm:ss')),
                update_flag: PermissionMap[item.outgoing_id] ? 'Y' : 'N'
            }));
            setOriginRows(response.data);
            setRows([ ...new Set((array).map(JSON.stringify)) ].map(JSON.parse));
        })
        .catch((error) => {
            appStore.capture();
        })
        .finally(() => {
            appStore.setLoading(false); 
        });
    }

    const handleInitSelect = () => {

        //출하상태
        var array = [
            {value:'', label:'전체'}
            ,{value:'S', label:'출하완료'}
            ,{value:'D', label:'출하취소'}
        ];
        setStatusOption(array);
        
        // 담당자 유형
        axios.get('/api/Common/CodeDetailList')
        .then((response) => { 

            var user_type_array_modal = [];
            for(let i=0; i<(response.data).length; i++){
                if((response.data)[i].code_id === '0020'){
                    user_type_array_modal.push({ value: (response.data)[i].code_detail_seq, label: (response.data)[i].code_detail_name });
                }
            }

            var quality_yn_array_modal = [
                {value:'Y', label:'Y'}
                ,{value:'N', label:'N'}
            ];

            setQualityYnModalOption(quality_yn_array_modal);
            setUserTypeModalOption(user_type_array_modal);
        })
        .catch((error) => {
            console.log(error);
        });
    }

    const handleInit = () => {
        setKeyword({
            search: '',
            status: ''
        })
        
        // Hide컬럼 숨기기.
        setColumnVisibilityModel({
            id: false,
            outgoing_number: true,
            outgoing_status: false,
            outgoing_status_name: true,
            outgoing_order_info: true,
            outgoing_partner_name: true,
            outgoing_partner_manager: true,
            outgoing_partner_manager_phone: true,
            outgoing_partner_manager_mail: true,
            deleted: true,
            updated: true,
            recent_update_user_name: true,
            recent_update_datetime: true,
        });
    };

    const handleReg = () => {
        setRegModalOpen(true);
        setModalTitle('출하 등록');
    };
    
    const UpdateClick = (object) => {
        setUpdateModalOpen(true);
        setModalTitle('출하 수정');
        setSelectOutgoingID(object.row.id);
    };

    const DeleteClick = (object) => {
        Swal.fire({
            title: '출하번호 '+object.row.outgoing_number+' 삭제',
            html : '출하번호 '+object.row.outgoing_number+'을(를) <span style="color:red; font-weight:bold;">삭제</span> 하시겠습니까?<br/>삭제하시면 복구 할 수 없습니다.',
            showCancelButton : true,
            confirmButtonColor : "#d33",
            confirmButtonText : "삭제",
            cancelButtonText : "닫기"
        }).then((result) => {
            if (result.isConfirmed) {
                if (appStore.loading) return;
                appStore.setLoading(true);

                axios.post('/api/p/Outgoing/Delete', new URLSearchParams({
                    delete_outgoing_id: object.row.id,
                    folder: 'Outgoing'
                }),
                { withCredentials: true })
                .then(function (response) {
                    if(response.status === 200){
                        Swal.fire({
                            title: '출하번호 '+object.row.outgoing_number+' 삭제 완료',
                            text: '정상적으로 출하번호 '+object.row.outgoing_number+'가 삭제 되었습니다.',
                            confirmButtonText: '확인',
                            timer: 5000,
                            timerProgressBar: true
                        }).then((result) => {
                            setRows((rows) => rows.filter((data) => data.id !== object.row.id));
                        });
                    }else{
                        appStore.capture();
                    }
                })
                .catch(function (error) {
                    appStore.capture();
                })
                .then(function () {
                    appStore.setLoading(false);
                });
            }
        });
    };

    const onSelectChange = (type, value) => {
        const nextKeyword = {
            ...keyword,
            [type] : value
        };
        setKeyword(nextKeyword);
    };

    const onChange = (e)=>{
        const {name, value} = e.target;
        const nextKeyword = {
            ...keyword,
            [name]: value, 
        };
        setKeyword(nextKeyword);
    };

    const onSubmitSearch = (e) => {
        //입력 검색어는 Enter로 조회.
        if (e.key === "Enter") {
          handleView();
        }
    };
    
    const handleRegSuccessSave = (regID) => {
        setModalTitle('출하 수정');
        setRegModalOpen(false);
        handleView();
        
        Swal.fire({
            title: '출하 등록 완료',
            text: '정상적으로 출하가 등록 되었습니다.',
            confirmButtonText: '확인',
            timer: 5000,
            timerProgressBar: true
        }).then((result) => {
            // 수정 화면 불러오기
            setUpdateModalOpen(true);
            setSelectOutgoingID(Number(regID));
        });
    };

    const handleExcel = () => {
        var filename = '출하관리'
        axios.get('/api/p/Outgoing/Excel',
        {   
            params : { search : keyword.search, status : keyword.status, file_name: filename },
            responseType:'blob'
        },
        { withCredentials: true })
        .then(function (response) {
            
            if(response.status === 200){
                filename = filename + ' ' + appStore.YYYY_MM_DD_HH_MI_SS();
                const link = document.createElement('a');
                link.href = URL.createObjectURL(response.data);
                link.setAttribute('download', filename+'.xlsx');
                document.body.appendChild(link);
                link.click();
            }
        })
        .catch(function (error) {
            appStore.capture();
        })
        /*
        axios.get('/api/p/ExcelUpload/outgoing',
        {   
            params : { file_name: filename },
            responseType:'blob'
        },
        { withCredentials: true })
        .then(function (response) {
            
            if(response.status === 200){
                filename = filename + ' ' + appStore.YYYY_MM_DD_HH_MI_SS();
                const link = document.createElement('a');
                link.href = URL.createObjectURL(response.data);
                link.setAttribute('download', filename+'.xlsx');
                document.body.appendChild(link);
                link.click();
            }
        })
        .catch(function (error) {
            appStore.capture();
        })
        */
    };
    
    return (
        <div style={ { width:'100%', display: String(MenuID) === String(0) ? 'hidden' : 'block' } }>
            <div className="menubox">
                <div className="menu-action">
                    <div className="menu-title">{ MenuName }</div>
                    <div className="menu-button">
                    { MenuUpdateYN === "Y"?
                    <Button 
                        onClick={ handleReg }
                        className="btn-p btn-u"
                        sx={{  
                            m: 1, 
                            fontSize: 15, 
                            color: "white", 
                            borderColor: "#FF3636", 
                            backgroundColor: "#FF3636",
                            ":hover": { boxShadow: "2px 2px 2px #FF3636" , backgroundColor: "#FF3636", borderColor: "#FF3636"}
                        }} 
                        variant="outlined">
                        등록
                    </Button> : <></> }
                    {isRegModalOpen  && MenuUpdateYN === 'Y' && (
                        <OutgoingRegModal
                        onClose={() => {
                            setRegModalOpen(false);
                        }}
                        title={modalTitle}
                        handleRegSuccessSave={handleRegSuccessSave}
                        userTypeModalOption={userTypeModalOption}
                        qualityYnModalOption={qualityYnModalOption}
                        MenuUpdateYN={MenuUpdateYN}
                        />
                    )}
                    <Button 
                        onClick={ handleExcel }
                        className="btn-p"
                        sx={{  
                            m: 1, 
                            fontSize: 15, 
                            color: "white", 
                            borderColor: "#00AC47", 
                            backgroundColor: "#00AC47",
                            ":hover": { boxShadow: "2px 2px 2px #00AC47" , backgroundColor: "#00AC47", borderColor: "#00AC47"}
                        }} 
                        variant="outlined">
                        엑셀
                    </Button>
                    <Button 
                        onClick={ handleInit }
                        className="btn-p"
                        sx={{  
                            m: 1, 
                            fontSize: 15, 
                            color: "white", 
                            borderColor: "black", 
                            backgroundColor: "black",
                            ":hover": { boxShadow: "2px 2px 2px black" , backgroundColor: "black", borderColor: "black"}
                        }} 
                        variant="outlined">
                        초기화
                    </Button>
                    <Button 
                        onClick={ handleView }
                        className="btn-p"
                        sx={{  
                            m: 1, 
                            fontSize: 15, 
                            color: "white", 
                            borderColor: "#3D63AE", 
                            backgroundColor: "#3D63AE",
                            ":hover": { boxShadow: "2px 2px 2px #3D63AE" , backgroundColor: "#3D63AE", borderColor: "#3D63AE"}
                        }} 
                        variant="outlined">
                        조회
                    </Button>
                    </div>
                </div>
                <div className="menu-keyword">
                    <div className="menu-keyword-sub">
                        <div className="menu-keyword-sub-title">
                            출하상태
                        </div>
                        <div className="menu-keyword-sub-keyword">
                            <Select className="menu-keyword-sub-keyword-select" placeholder="출하상태" onChange={(e) => onSelectChange('status',e.value)} value={statusOption.filter(function (option) { return option.value === keyword.status;  })} options={statusOption} noOptionsMessage={() => "조회되는 항목 없음"} />
                        </div>
                    </div>
                    <div className="menu-keyword-sub">
                        <div className="menu-keyword-sub-keyword" style={ { maxWidth: '300px' } }>
                            <input type="text" placeholder="검색" value={keyword.search} name="search" onChange={(e) => onChange(e) } onKeyPress={onSubmitSearch} autoComplete="off" />
                        </div>
                    </div>
                </div>
            </div>
            <div className="grid">
                <div className="grid_sub" style={ { width: '100%', fontSize: '17px' } }>
                    <DataGrid
                        className="grid_main"
                        rows={rows}
                        columns={columns}
                        slots={{
                            noRowsOverlay: GridNoRow,
                        }}
                        columnVisibilityModel={columnVisibilityModel}
                        AlternatingRowBackground="LavenderBlush"
                        rowsPerPageOptions={[20, 50, 100]}
                    />
                    {isUpdateModalOpen && (
                        <OutgoingUpdateModal
                        onClose={() => {
                            setUpdateModalOpen(false);
                        }}
                        title={modalTitle}
                        id={selectOutgoingID}
                        originRows={originRows.filter(row => String(row.outgoing_id) === String(selectOutgoingID))}
                        handleView={handleView}
                        userTypeModalOption={userTypeModalOption}
                        qualityYnModalOption={qualityYnModalOption}
                        MenuUpdateYN={MenuUpdateYN}
                        />
                    )}
                </div>
            </div>
        </div>
    )
}

const AppWrap = styled.div`
  text-align: center;
  margin: 50px auto;
`;

export default Outgoing;
